/**
 * Route definitions for the billing section (Billing & Payments page,
 * payment method management, tax file uploads, and payment detail).
 * Mirrors the pattern in views/orders/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { GraphQL } from "@rpi/openapi-api";
import { featureFlags } from "../../../featureFlags";
import { withHandle } from "../../../utils/route.util";
import { BillingView } from "./BillingView";
import { PaymentMethodCreateView } from "./PaymentMethodCreateView";
import { PaymentMethodEditView } from "./PaymentMethodEditView";
import { PaymentView } from "./PaymentView";
import { PaymentsFilterInner, path as paymentsFilterPath } from "./PaymentsFilter";
import { TaxFileUploadView } from "./TaxFileUploadView";
import { SandboxGuard } from "../../../components/SandboxGuard";

export const paymentsFilterRoute: RouteObject = {
  path: paymentsFilterPath,
  element: <PaymentsFilterInner />,
  ...withHandle("admin-billing-filter"),
};

export const billingRoutes: RouteObject[] = [
  {
    path: "billing",
    element: <BillingView />,
    ...withHandle("admin-billing"),
    children: [
      ...(featureFlags.newSearchExperience ? [paymentsFilterRoute] : []),
      {
        path: "payment-methods",
        ...withHandle("admin-billing-payment-methods", {
          requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin, GraphQL.DashboardUserRole.User],
        }),
        children: [
          {
            path: "create",
            element: <PaymentMethodCreateView redirect="../../" />,
            ...withHandle("payment-method-create"),
          },
          {
            path: ":token/edit",
            element: <PaymentMethodEditView redirect="../../" />,
            ...withHandle("payment-method-edit"),
          },
        ],
      },
      {
        path: "file-upload",
        ...withHandle("admin-billing-file-upload", {
          requiredRole: [GraphQL.DashboardUserRole.CustomerAdmin],
        }),
        element: <TaxFileUploadView />,
      },
    ],
  },
  {
    path: "payments",
    element: <SandboxGuard redirectTo="/dashboard/admin/billing" />,
    ...withHandle("admin-payments"),
    children: [
      {
        path: ":id",
        element: <PaymentView />,
        ...withHandle("admin-payment-detail"),
      },
    ],
  },
];
